import { ZohoClient } from './ZohoClient';
import { Campaign } from '../../types/campaign';
import { ZOHO_CONFIG } from '../../config/zoho';

export class ZohoSync {
  private client: ZohoClient;
  private syncInterval: number;
  private syncTimer: NodeJS.Timer | null = null;

  constructor() {
    this.client = ZohoClient.getInstance();
    this.syncInterval = ZOHO_CONFIG.syncInterval;
  }

  startSync(onUpdate: (campaigns: Campaign[]) => void) {
    // Initial sync
    this.syncCampaigns(onUpdate);

    // Set up periodic sync
    this.syncTimer = setInterval(() => {
      this.syncCampaigns(onUpdate);
    }, this.syncInterval);
  }

  stopSync() {
    if (this.syncTimer) {
      clearInterval(this.syncTimer);
      this.syncTimer = null;
    }
  }

  private async syncCampaigns(onUpdate: (campaigns: Campaign[]) => void) {
    try {
      const campaigns = await this.client.listCampaigns();
      
      // Fetch detailed data for each campaign
      const detailedCampaigns = await Promise.all(
        campaigns.map(async (campaign) => {
          const [metrics, analytics] = await Promise.all([
            this.client.getCampaignMetrics(campaign.id),
            this.client.getTargetAnalytics(campaign.id)
          ]);

          return {
            ...campaign,
            metrics,
            analytics
          };
        })
      );

      onUpdate(detailedCampaigns);
    } catch (error) {
      console.error('Campaign sync failed:', error);
    }
  }
}